/**
 * Coming Soon — early access sign-up
 *
 * Vanilla JS, no dependencies. Submits the email field straight to Klaviyo's
 * client-side "Create Client Subscription" API (no server / app required):
 * https://developers.klaviyo.com/en/reference/create_client_subscription
 *
 * Request shape mirrors the one used on the quiz (templates/page.quiz.liquid)
 * — that endpoint is live-tested and working, so this intentionally does not
 * invent a different API shape.
 *
 * The form itself stays hidden by default — a secondary text link
 * ([data-coming-soon-toggle], pointing at the form's id via aria-controls)
 * reveals it on click. Nothing about the Klaviyo submit flow below changes;
 * this only controls whether the form is visible.
 */
(function () {
  'use strict';

  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var KLAVIYO_REVISION = '2025-07-15'; // pinned API revision — bump deliberately

  // PUBLIC site ID / list ID only. Never put a private API key (pk_...) here.
  var KLAVIYO_COMPANY_ID = 'TqB7aj';
  var KLAVIYO_LIST_ID = 'WcmdVY';

  function init() {
    var forms = document.querySelectorAll('[data-coming-soon-form]');
    for (var i = 0; i < forms.length; i++) {
      forms[i].addEventListener('submit', handleSubmit);
    }

    var toggles = document.querySelectorAll('[data-coming-soon-toggle]');
    for (var j = 0; j < toggles.length; j++) {
      toggles[j].addEventListener('click', handleToggleClick);
    }
  }

  function handleToggleClick(event) {
    var toggle = event.currentTarget;
    var targetId = toggle.getAttribute('aria-controls');
    var target = targetId ? document.getElementById(targetId) : null;
    if (!target) return;

    var isHidden = target.hasAttribute('hidden');
    if (isHidden) {
      target.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
      var input = target.querySelector('input[type="email"]');
      if (input) input.focus();
    } else {
      target.setAttribute('hidden', 'hidden');
      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    var form = event.currentTarget;
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var messageEl = form.parentElement
      ? form.parentElement.querySelector('[data-coming-soon-message]')
      : null;
    var email = input && input.value ? input.value.trim() : '';

    clearMessage(messageEl);

    if (!isValidEmail(email)) {
      showMessage(messageEl, 'Please enter a valid email address.', 'error');
      if (input) input.focus();
      return;
    }

    setLoading(form, button, true);

    fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID), {
      method: 'POST',
      headers: {
        'content-type': 'application/vnd.api+json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify(buildSubscriptionPayload(email))
    })
      .then(function (response) {
        setLoading(form, button, false);

        if (response.status === 202) {
          showConfirmation(form, messageEl);
        } else {
          showMessage(messageEl, 'Something went wrong — please try again.', 'error');
        }
      })
      .catch(function () {
        setLoading(form, button, false);
        showMessage(messageEl, 'Something went wrong — please try again.', 'error');
      });
  }

  function buildSubscriptionPayload(email) {
    var properties = { signup_source: 'welcome_page' };
    var utm = getUTMParams();
    Object.keys(utm).forEach(function (key) {
      properties[key] = utm[key];
    });

    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Welcome Page',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: properties,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
        }
      }
    };
  }

  function getUTMParams() {
    var params = new URLSearchParams(window.location.search);
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var out = {};
    keys.forEach(function (key) {
      var value = params.get(key);
      if (value) out[key] = value;
    });
    return out;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function setLoading(form, button, isLoading) {
    form.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    if (!button) return;
    button.disabled = isLoading;
    button.textContent = isLoading ? 'Joining…' : 'Join';
  }

  function showConfirmation(form, messageEl) {
    form.setAttribute('hidden', 'hidden');
    if (!messageEl) return;

    messageEl.hidden = false;
    messageEl.textContent = "You're on the list — we'll be in touch soon.";
    messageEl.classList.remove('coming-soon__form-message--error', 'coming-soon__form-message--success');
    messageEl.classList.add('coming-soon__form-message--success');
    // Brand-styled inline confirmation: Eden text on a paper chip so it stays
    // legible over the section's dark photo/scrim background.
    messageEl.style.cssText =
      "font-family:'IBM Plex Sans', Helvetica, Arial, sans-serif;" +
      'font-size:15px;line-height:1.6;color:#163012;' +
      'background:#f4efe1;border-radius:8px;padding:13px 16px;' +
      'margin:12px 0 0;display:inline-block;';
  }

  function showMessage(el, text, state) {
    if (!el) return;
    el.style.cssText = '';
    el.textContent = text;
    el.hidden = false;
    el.classList.remove('coming-soon__form-message--error', 'coming-soon__form-message--success');
    el.classList.add('coming-soon__form-message--' + state);
  }

  function clearMessage(el) {
    if (!el) return;
    el.style.cssText = '';
    el.hidden = true;
    el.textContent = '';
    el.classList.remove('coming-soon__form-message--error', 'coming-soon__form-message--success');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
